module.exports = __webpack_public_path__ + "img/settings-tax-rates.5bf82eea.svg";